import apiClient from './client';
import type { StudyAnalyticsData } from '../types/studyAnalytics';

export async function fetchStudyAnalytics(
  certification?: string,
): Promise<StudyAnalyticsData> {
  const { data } = await apiClient.get<StudyAnalyticsData>(
    '/api/sessions/my/study-analytics',
    { params: certification ? { certification } : undefined },
  );
  return data;
}
